<template>
  <div>
    <div id="content">
      <div id="left">
        <el-menu :default-active="active.toString()" class="el-menu-vertical-demo" @select="handleSelect">
          <el-menu-item index="0">
            <span slot="title"><b>Breast cancer</b></span>
          </el-menu-item>
          <el-menu-item index="1">
            <span slot="title"><b>PDAC</b></span>
          </el-menu-item>
          <el-menu-item index="2">
            <span slot="title"><b>Skin cancer</b></span>
          </el-menu-item>
          <el-menu-item index="3">
            <!--            <i class="el-icon-view"></i>-->
            <span slot="title"><b>Melanoma</b></span>
          </el-menu-item>
          <el-menu-item index="4">
            <span slot="title"><b>Prostate cancer</b></span>
          </el-menu-item>
          <el-menu-item index="5">
            <span slot="title"><b>Liver cancer</b></span>
          </el-menu-item>
          <el-menu-item index="6">
            <span slot="title"><b>Ovarian cancer</b></span>
          </el-menu-item>
          <el-menu-item index="7">
            <span slot="title"><b>Glioblastoma</b></span>
          </el-menu-item>
          <el-menu-item index="8">
            <span slot="title"><b>Colorectal Cancer</b></span>
          </el-menu-item>
          <el-menu-item index="9">
            <span slot="title"><b>Cervical Cancer</b></span>
          </el-menu-item>
          <el-menu-item index="10">
            <span slot="title"><b>Intestine Cancer</b></span>
          </el-menu-item>
          <el-menu-item index="11">
            <span slot="title"><b>Bladder Cancer</b></span>
          </el-menu-item>
          <el-menu-item index="12">
            <span slot="title"><b>Brain metastases</b></span>
          </el-menu-item>
          <el-menu-item index="13">
            <span slot="title"><b>Lung cancer</b></span>
          </el-menu-item>
        </el-menu>
      </div>
      <div id="right">
        <h2>
          {{datasetName[active]}}
        </h2>
        <div style="text-align: justify;word-spacing: 5px;line-height: 25px;font-size: 16px;margin: 5px;color: black">{{description[active]}}</div>
        <img :src="pic_path[active]" alt="pic error">
        <!-- 150 180 120 150-->
        <div style="white-space: pre; height: 50px;float: bottom">{{cite[active]}}</div>
      </div>
    </div>
<!--    <el-container>-->
<!--      <el-aside width="20%" style="min-width: 200px; margin-left: 10px; max-height: 550px">-->
<!--        <el-menu :default-active="active" class="el-menu-vertical-demo" @select="handleSelect">-->
<!--          <el-menu-item index="0">-->
<!--            <span slot="title">Breast cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="1">-->
<!--            <span slot="title">PDAC</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="2">-->
<!--            <span slot="title">Skin cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="3">-->
<!--&lt;!&ndash;            <i class="el-icon-view"></i>&ndash;&gt;-->
<!--            <span slot="title">Melanoma</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="4">-->
<!--            <span slot="title">Prostate cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="5">-->
<!--            <span slot="title">Liver cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="6">-->
<!--            <span slot="title">Ovarian cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="7">-->
<!--            <span slot="title">Glioblastoma</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="8">-->
<!--            <span slot="title">Colorectal Cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="9">-->
<!--            <span slot="title">Cervical Cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="10">-->
<!--            <span slot="title">Intestine Cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="11">-->
<!--            <span slot="title">Bladder Cancer</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item index="12">-->
<!--            <span slot="title">Lung cancer</span>-->
<!--          </el-menu-item>-->
<!--        </el-menu>-->
<!--      </el-aside>-->
<!--      <el-main>-->
<!--        <div class="my-container" style="height: 500px;">-->
<!--          <h2>-->
<!--            {{datasetName[active]}}-->
<!--          </h2>-->
<!--          <div style="text-align: justify;word-spacing: 5px;line-height: 30px;font-size: 18px;margin-bottom: 5px;color: black">{{description[active]}}</div>-->
<!--          <img :src="pic_path[active]" alt="pic error" height="150px">-->
<!--          <div style="white-space: pre; height: 50px;float: bottom">{{cite[active]}}</div>-->
<!--        </div>-->
<!--      </el-main>-->
<!--    </el-container>-->
    <div class="my-container">
      <h2>
        {{datasetName[active]}} dataset
      </h2>
      <div>
        <el-table
            :data="tableData[active].slice((currentPage-1)*pageSize,currentPage*pageSize)"
            stripe
            :row-style="{height: '30px'}"
            :cell-style="{padding: '0', color: 'black', margin: '0'}"
            :header-cell-style="{color: 'black'}">
          <el-table-column prop="pmid" label="PMID" width="120" sortable>
          </el-table-column>
          <el-table-column prop="title" label="title" min-width="280" sortable show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="journal" label="Journal" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="year" label="year" width="80" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="svg" label="SVG" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.haveSVG === 'F'" class="my-span">link</span>
              <span v-else><a v-on:click="gotoDetails(scope.row.svg)" class="my-a">link</a></span>
              <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            </template>
          </el-table-column>
          <el-table-column prop="cellType" label="celltype" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.haveCelltype === 'F'" class="my-span">link</span>
              <span v-else><a v-on:click="gotoDetails(scope.row.cellType)" class="my-a">link</a></span>
              <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
<!--              <a v-on:click="gotoDetails(scope.row.cellType)" class="my-a">link</a>-->
            </template>
          </el-table-column>
          <el-table-column prop="marker" label="marker" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.haveCelltype === 'F'" class="my-span">link</span>
              <span v-else><a v-on:click="gotoDetails(scope.row.marker)" class="my-a">link</a></span>
              <!--              <a target="_blank" class="buttonText" v-on:click="gotoDetails(DETAILS)">link</a>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[1,5,10,20]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tableData[active].length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dataset_v1",
  data(){
    return {
      active: 0,
      datasetName: ["BreastCancer", "PDAC", "SkinCancer", "Melanoma", "ProstateCancer",
        "LiverCancer", "OvarianCancer","Glioblastoma","ColorectalCancer", "CervicalCancer",
        "IntestineCancer","BladderCancer","Brainmetastases","LungCancer"],
      description: [
          "Breast  cancers  are  complex  cellular  ecosystems  where  heterotypic  interactions  play  central  roles  in  disease  progression and response to therapy. However, our knowledge of their cellular composition and organization is limited.  Using single-cell signatures, we deconvoluted large breast cancer cohorts to stratify them into nine clusters, termed ‘ecotypes’, with unique cellular compositions and clinical out-comes. This study provides a comprehensive transcriptional atlas of the cellular architecture of breast cancer.",
          "Studying primary PDAC tumors from different patients, we identified enrichments  of  specific  cell  types  and  subpopulations  across  spatially restricted regions of the tissue. Our approach for combining these two complementary and powerful technologies is easily scalable to any architecturally complex tissue and has the potential to provide meaningful biological insight across a range of fields. ",
          "To define the cellular composition and architecture of cutaneous squamous cell carcinoma (cSCC), we combined single-cell RNA sequencing with spatial transcriptomics and multiplexed ion beam imaging from a series of human cSCCs and matched normal skin. cSCC exhibited four tumor subpopulations, three recapitulating normal epidermal states, and a tumor-specific keratinocyte (TSK) population unique to cancer, which localized to a fibrovascular niche. Integration of single-cell and spatial data mapped ligand-receptor networks to specific cell types, revealing TSK cells as a hub for intercellular communication. Multiple features of potential immunosuppression were observed, including T regulatory cell (Treg) co-localization with CD8 T cells in compartmentalized tumor stroma. Finally, single-cell characterization of human tumor xenografts and in vivo CRISPR screens identified essential roles for specific tumor subpopulation-enriched gene networks in tumorigenesis. These data define cSCC tumor and stromal cell subpopulations, the spatial niches where they interact, and the communicating gene networks that they engage in cancer.",
          "Cutaneous malignant melanoma (melanoma) is characterized by a high mutational load, extensive intertumoral and intratumoral genetic heterogeneity, and complex tumor microenvironment (TME) interactions. Further insights into the mechanisms underlying melanoma are crucial for understanding tumor progression and responses to treatment. Here we adapted the technology of spatial transcriptomics (ST) to melanoma lymph node biopsies and successfully sequenced the transcriptomes of over 2,200 tissue domains. In conclusion, using the ST technology to generate gene expression profiles reveals a detailed landscape of melanoma metastases. This should inspire researchers to integrate spatial information into analyses aiming to identify the factors underlying tumor progression and therapy outcome.",
          "Intra-tumor heterogeneity is one of the biggest challenges in cancer treatment today. Here we investigate tissue-wide gene expression heterogeneity throughout a multifocal prostate cancer using the spatial transcriptomics (ST) technology. Utilizing a novel approach for deconvolution, we analyze the transcriptomes of nearly 6750 tissue regions and extract distinct expression profiles for the different tissue components, such as stroma, normal and PIN glands, immune cells and cancer. We distinguish healthy and diseased areas and thereby provide insight into gene expression changes during the progression of prostate cancer. Compared to pathologist annotations, we delineate the extent of cancer foci more accurately, interestingly without link to histological changes. We identify gene expression gradients in stroma adjacent to tumor regions that allow for re-stratification of the tumor microenvironment. The establishment of these profiles is the first step towards an unbiased view of prostate cancer and can serve as a dictionary for future studies.",
          "Malignant cell growth is fueled by interactions between tumor cells and the stromal cells composing the tumor microenvironment. The human liver is a major site of tumors and metastases, but molecular identities and intercellular interactions of different cell types have not been resolved in these pathologies. Here, we apply single cell RNA-sequencing and spatial analysis of malignant and adjacent non-malignant liver tissues from five patients with cholangiocarcinoma or liver metastases. We find that stromal cells exhibit recurring, patient-independent expression programs, and reconstruct a ligand–receptor map that highlights recurring\n" +
            "tumor–stroma interactions. By combining transcriptomics of laser-capture microdissected regions, we reconstruct a zonation atlas of hepatocytes in the non-malignant sites and characterize the spatial distribution of each cell type across the tumor microenvironment. Our analysis provides a resource for understanding human liver malignancies and may expose potential points of interventions.",
          "Although ovarian cancer may occur at any age, it is more common in patients older than 50 years. Patients often present with nonspecific pelvic or abdominal symptoms. Initial diagnostic tests include transvaginal ultrasonography and serum cancer antigen 125 measurement; however, these tests are not specific for ovarian cancer. Conventional treatment includes surgical debulking followed by chemotherapy. Prognosis is typically determined by the cancer stage and grade, although future treatment may depend on tumor genetic composition. Epithelial ovarian cancer is the most common type of ovarian cancer, and because 70 percent of cases are diagnosed at stage III or IV, it is associated with a poor prognosis. Preventive visits provide an opportunity to identify and educate women at increased risk of ovarian cancer, but routine screening is not recommended. Women with a family history of ovarian cancer or a known associated genetic syndrome should be offered genetic counseling or a discussion of available preventive interventions, respectively.",
          "Glioblastomas are highly malignant tumors of the central nervous system. Evidence suggests that these tumors display large intra- and inter-patient heterogeneity hallmarked by subclonal diversity and dynamic adaptation amid developmental hierarchies. However, the source for dynamic reorganization of cellular states within their spatial context remains elusive. Here, we in-depth characterized glioblastomas by spatially resolved transcriptomics, metabolomics and proteomics. By deciphering exclusive and shared transcriptional programs across patients, we inferred that glioblastomas develop along defined neural lineages and adapt to inflammatory or metabolic stimuli reminiscent of reactive transformation in mature astrocytes.Metabolic profiling and imaging mass cytometry supported the assumption that tumor heterogeneity is dictated by microenvironmental alterations. Analysis of copy number variation (CNV) revealed a spatially cohesive organization of subclones associated with reactive transcriptional programs, confirming that environmental stress gives rise to selection pressure. ",
          "Liver metastasis, the leading cause of colorectal cancer mortality, exhibits a highly heterogeneous and suppressive immune microenvironment. Here, we sequenced 97 matched samples by using single-cell RNA-seq and Spatial Transcriptomics. Strikingly, metastatic microenvironment underwent remarkable spatial reprogramming of immunosuppressive cells such as MRC1+ CCL18+ M2-like macrophages. We further developed scMetabolism, a computational pipeline for quantifying single-cell metabolism, and observed that those macrophages harbored enhanced metabolic activity. Interestingly, neoadjuvant chemotherapy could block this status and restore the antitumor immune balance in responsive patients, while the non-responsive patients deteriorated into a more suppressive one. Our work described the immune evolution of metastasis and uncovered the black box of how tumors respond to neoadjuvant chemotherapy. ",
          "Cervical cancer is a serious health problem, with nearly 500 000 women developing the disease each year worldwide. Most cases occur in less developed countries where no effective screening systems are available. Risk factors include exposure to human papillomavirus, smoking, and immune-system dysfunction. Most women with early-stage tumours can be cured, although long-term morbidity from treatment is common. Results of randomised clinical trials have shown that for women with locally advanced cancers, chemoradiotherapy should be regarded as the standard of care; however, the applicability of this treatment to women in less developed countries remains largely untested. Many women with localised (stage IB) tumours even now receive various combinations of surgery and radiotherapy, despite unresolved concern about the morbidity of this approach compared with definitive radiotherapy or radical surgery. Treatment of recurrent cervical cancer remains largely ineffective. Quality of life should be taken into account in treatment of women with primary and recurrent cervical cancer.",
          "Presently, several studies have found a significant difference in fecal flora between normal individuals and patients with gastric cancer. Although clinical research on the feedback mechanism of gastric flora and gut microbiota is lacking, clarifying the relationship between gut microbiota and the characteristics of cancer is significant for the early diagnosis of gastric cancer. This study was conducted to review the results of several studies in the past 5 years and analyze the intestinal bacteria in patients with gastric cancer and compare them with those in patients with esophageal and small intestine cancers. It was found that the gut microbiota in patients with gastric cancer was similar to that in patients with esophageal cancer. However, making an analysis and comparing the gut microbiota in patients with small intestine and gastric cancers was impossible due to the low incidence of small intestinal cancer.",
          "Bladder cancer is a complex disease associated with high morbidity and mortality rates if not treated optimally. Awareness of haematuria as the major presenting symptom is paramount, and early diagnosis with individualised treatment and follow-up is the key to a successful outcome. For non-muscle-invasive bladder cancer, the mainstay of treatment is complete resection of the tumour followed by induction and maintenance immunotherapy with intravesical BCG vaccine or intravesical chemotherapy. For muscle-invasive bladder cancer, multimodal treatment involving radical cystectomy with neoadjuvant chemotherapy offers the best chance for cure. Selected patients with muscle-invasive tumours can be offered bladder-sparing trimodality treatment consisting of transurethral resection with chemoradiation. Advanced disease is best treated with systemic cisplatin-based chemotherapy; immunotherapy is emerging as a viable salvage treatment for patients in whom first-line chemotherapy cannot control the disease. Developments in the past 2 years have shed light on genetic subtypes of bladder cancer that might differ from one another in response to various treatments.",
          "Spatial transcriptomics is an emerging technology that measures gene expression while preserving spatial information. Here, we present a method to determine localization of specific T cell clones by obtaining T cell receptor (TCR) sequences from spatial transcriptomics assays. Our method uses an existing commercial spatial transcriptomics platform and open-source software for analysis, allowing simple and inexpensive integration with archived samples and existing laboratory workflows. Using human brain metastasis samples, we show that TCR sequences are readily obtained from human tumor tissue and that these sequences are recapitulated by single-cell sequencing methods. This technique will permit detailed studies of the spatial organization of the human T cell repertoire, such as the identification of tumor-infiltrating and tumor-excluded T cell clones.Competing Interest StatementThe authors have declared no competing interest.",
          "Lung disease accounts for every sixth death globally. Profiling the molecular state of all lung cell types in health and disease is currently revolutionizing the identification of disease mechanisms and will aid the design of novel diagnostic and personalized therapeutic regimens. Recent progress in high-throughput techniques for single-cell genomic and transcriptomic analyses has opened up new possibilities to study individual cells within a tissue, classify these into cell types, and characterize variations in their molecular profiles as a function of genetics, environment, cell–cell interactions, developmental processes, aging, or disease. Integration of these cell state definitions with spatial information allows the in-depth molecular description of cellular neighborhoods and tissue microenvironments, including the tissue resident structural and immune cells, the tissue matrix, and the microbiome. The Human Cell Atlas consortium aims to characterize all cells in the healthy human body and has prioritized lung tissue as one of the flagship projects. Here, we present the rationale, the approach, and the expected impact of a Human Lung Cell Atlas."
      ],
      pic_path: [
        require("@/assets/Dataset/202101.png"),
        require("@/assets/Dataset/202102.png"),
        require("@/assets/Dataset/202103.png"),
        require("@/assets/Dataset/202104.png"),
        require("@/assets/Dataset/202105.png"),
        require("@/assets/Dataset/202106.png"),
        require("@/assets/Dataset/202107.png"),
        require("@/assets/Dataset/202108.png"),
        require("@/assets/Dataset/202109.png"),
        require("@/assets/Dataset/202110.jpg"),
        require("@/assets/Dataset/202111.jpg"),
        require("@/assets/Dataset/202112.jpg"),
        require("@/assets/Dataset/202113.jpg"),
        require("@/assets/Dataset/202114.png")
      ],
      cite: [
        "Mapping breast cancer heterogeneity using SRT.\n Sunny Z. Wu et al. Nature Genetics. 2021.",
        "Annotated PDAC tumor cryosection on the ST slide.\n Reuben Moncada et al. Nature Biotechnology. 2020." ,
        "Hematoxylin and eosin (H&E) staining of tissue sections and unbiased clustering of ST spots.\n Andrew L. Ji et al. Cell. 2020.",
        "H&E-stained tissue image with pathologic annotation.\n Thrane et al. Cancer Research. 2018.",
        "Annotated brightfield image of H&E-stained tissue section.\n Emelie Berglund et al. Nature Communications. 2018.",
        "H&E staining of malignant and non-malignant sites from patient p4, separated by the white dashed line. Scale bar is 100 µm.\n Thrane et al. Molecular Systems Biology. 2020.",
        "H&E-stained tissue image with pathologic annotation.\n Thrane et al. Cancer Research. 2018.",
        "H&E-stained tissue image with pathologic annotation.\n Vidhya M. Ravi et al. bioRxiv. 2021.",
        "The spatial transcriptomics of selected immune cell subsets in colon or liver tumor-normal samples.\n Yingcheng Wu et al. Cancer Discovery. 2022.",
        "H&E-stained tissue image with pathologic annotation.\n baidu.com",
        "H&E-stained tissue image with pathologic annotation.\n baidu.com 2021.",
        "H&E-stained tissue image with pathologic annotation.\n Ashish M Kamat, Noah M Hahn et al. 2016.",
        "H&E-stained tissue image with pathologic annotation.\n William H.Hudson, Lisa J.Sudmeier bioRxiv. 2021.",
        "H&E-stained tissue image with pathologic annotation.\n Li Zhang et al. bioRxiv. 2021."
      ],
      tableData: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      Model: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10 // 每页的数据条数
    }
  },
  created() {
    this.getRouterData()
  },
  mounted() {
    this.getDatasetInformation()
  },
  methods: {
    getDatasetInformation() {
      let _this = this
      // console.log(_this.form)
      // _this.$axios.get(
      //     'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/models')
      //     .then(function (response){
      //       console.log('models:')
      //       console.log(response)
      //       _this.Model = response.data
      //     })
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/datasets')
          .then(function (response){
            console.log('datasets:')
            console.log(response)
            _this.tableData = response.data
          })
    },
    getRouterData() {
      let _this = this
      let name = _this.$route.params.type
      console.log('name', name)
      if (name === undefined){
        _this.active = 0
      }
      else{
        _this.active = _this.datasetName.indexOf(name)
        console.log('active', _this.active)
      }
    },
    gotoDetails(DETAILS) {
      console.log(DETAILS)
      this.$router.push({
        path: DETAILS
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
      this.active = key
      this.$router.replace("/Dataset/type/" + this.datasetName[key])
      // console.log(this.$route.fullPath)
      // console.log(this.$route.path)
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    }
  }
}
</script>

<style scoped>
#content{
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
#left{
  width: 20%;
  min-width: 200px;
  height: 500px;
  overflow: auto;
  position:relative;
  display: flex;
  flex-direction: column;
  /*margin-top: 10px;*/
}
#right{
  flex: 1;
  height: 500px;
  margin: 0 0 0 5px;
  padding: 0;
  background-color: #FFFFFF;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*align-items: flex-end;*/
  /*justify-content: flex-end;*/
  /*margin-right: 10px;*/
}

#left .el-menu .el-menu-item{
  color: black;
  /*font-size: 18px;*/
}
.my-a{
  cursor:pointer;
  color: blue;
  text-decoration:underline;
}
.my-span{
  text-decoration: line-through;
  color: #aaaaaa;
}
</style>
